import { render, staticRenderFns } from "./navBox.vue?vue&type=template&id=3093bce2&scoped=true"
import script from "./navBox.vue?vue&type=script&lang=js"
export * from "./navBox.vue?vue&type=script&lang=js"
import style0 from "./navBox.vue?vue&type=style&index=0&id=3093bce2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3093bce2",
  null
  
)

export default component.exports